export const decodeRedirectDomain = (value: string): string => {
  try {
    return atob(value);
  } catch {
    return value;
  }
};
